import React, { useEffect, useState } from "react";
import { useFormik } from 'formik';
import axios from 'axios';
import { BASE_URL, SAVE_PRINTER, GET_DEVICE_CONFIG } from '../utlilities/config'; 
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getWebUserInfo, initializeWebUserInfo } from "../utlilities/webConfig";
import { FiPrinter, FiServer, FiMonitor, FiSave, FiInfo, FiZoomIn } from 'react-icons/fi';

const ApplicationSettings = () => {
  const token = localStorage.getItem('accessToken');
  const [printers, setPrinters] = useState([]);
  const [systemName, setSystemName] = useState('');
  const [loading, setLoading] = useState(false);
  const [systemId, setSystemId] = useState();
  const [sysInfo, setSysInfo] = useState({});

  // Zoom factor options
  const zoomFactorOptions = [
    { name: '1.0', value: '1' },
    { name: '0.9', value: '0.9' },
    { name: '0.8', value: '0.8' },
    { name: '0.7', value: '0.7' }
  ];

  // Dummy data for pharmacy bill type
  const phBillTypeOptions = [
    { name: 'Normal', value: 'Normal' },
    { name: 'DOTMATRIX', value: 'DOTMATRIX' },
    { name: 'KOT', value: 'KOT' }
  ];

  // Dummy data for pharmacy bill template
  const phBillTemplateOptions = [
    { name: 'A5', value: 'A5' },
    { name: 'KOT', value: 'KOT' }
  ];

  const isElectron = () => {
    return window && window.process && window.process.type;
  };

  let ipcRenderer;

  if (isElectron()) {
      ipcRenderer = window.require('electron').ipcRenderer;
  }

  useEffect(() => {
    const fetchData = async () => {
        let sysinfo;

        if (isElectron()) {
            sysinfo = await ipcRenderer.invoke('store-get', 'userInfo');
            setSysInfo(sysinfo);
        } else {
            initializeWebUserInfo();
            sysinfo = getWebUserInfo().sysInfo; // Fetch from webConfig
            setSysInfo(sysinfo);
        }
    };

    fetchData();
  }, []);
  
  const [initialFormValues, setInitialFormValues] = useState({
    billPrinter: '',
    resultPrinter: '',
    barcodePrinter: '',
    zoomFactor: '',

    opBillPrinter: '',
    opBillCardPrinter: '',
    opRecieptPrinter: '',
    pharmacyBillPriinter: '',
    phbilltype: '',
    phbilltemplate: '',
    deviceConfig: '',
  });
  
  const getPrinters = async () => {
    if (isElectron()) {
      try {
        const printers = await ipcRenderer.invoke('get-printers');
        setPrinters(printers);
      } catch (error) {
        console.error('Error fetching printers:', error);
      }
    } else {
      console.log('Not running in Electron');
    }
  };

  const getSystem = async () => {
    if (isElectron()) {
      try {
        const systemname = await ipcRenderer.invoke('get-system');
        setSystemName(systemname);
        return systemname;
      } catch (error) {
        console.error('Error fetching system name:', error);
        return null;
      }
    } else {
      console.log('Not running in Electron');
      return null;
    }
  };

  const getData = async (sysName) => {
    if (!sysName) return;

    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_DEVICE_CONFIG}`, {
        headers: {
          'TenantName': 'Abcd',
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        const data = response.data.data;

        const matchedSystem = data.find(item => item.SystemName === sysName);

        if (matchedSystem) {
          setSystemId(matchedSystem?.SystemID);
          
          // Parse DeviceConfig if it's a JSON string (API returns DeviceConfig with capital D)
          let parsedDeviceConfig = {};
          const deviceConfigValue = matchedSystem.DeviceConfig || matchedSystem.deviceConfig || '';
          
          if (deviceConfigValue) {
            try {
              parsedDeviceConfig = typeof deviceConfigValue === 'string' 
                ? JSON.parse(deviceConfigValue) 
                : deviceConfigValue;
            } catch (e) {
              console.error('Error parsing DeviceConfig:', e);
              parsedDeviceConfig = {};
            }
          }

          setInitialFormValues({
            billPrinter: matchedSystem.BillPrinter || '',
            resultPrinter: matchedSystem.ResultPrinter || '',
            barcodePrinter: matchedSystem.BarcodePrinter || '',
            zoomFactor: matchedSystem.ZoomFactor ? String(matchedSystem.ZoomFactor) : '',

            opBillPrinter: matchedSystem.OpBillPrinter || '',
            opBillCardPrinter: matchedSystem.OpBillCardPrinter || '',
            opRecieptPrinter: matchedSystem.opRecieptPrinter || '' ,
            pharmacyBillPriinter: matchedSystem.pharmacyBillPriinter || '',
            phbilltype: parsedDeviceConfig.phbilltype || '',
            phbilltemplate: parsedDeviceConfig.phbilltemplate || '',
            deviceConfig: deviceConfigValue,
          });
        } else {
          console.log('No matching system found');
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await getPrinters();
      const sysName = await getSystem();
    };
    initialize();
  }, []);

  useEffect(() => {
    if (systemName) {
      getData(systemName);
    }
  }, [systemName]);

  const formik = useFormik({
    initialValues: initialFormValues,
    enableReinitialize: true,  
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        setSubmitting(true);
        setLoading(true);

        // Build deviceConfig as JSON
        const deviceConfigJson = JSON.stringify({
          phbilltype: values.phbilltype,
          phbilltemplate: values.phbilltemplate
        });

        const data = {
          sysID: systemId,
          sysName: systemName,
          billPrinter: values.billPrinter,
          resultPrinter: values.resultPrinter,
          barcodePrinter: values.barcodePrinter,
          zoomFactor: values.zoomFactor,
          opBillPrinter: values.opBillPrinter,
          OpBillCardPrinter: values.opBillCardPrinter,
          opRecieptPrinter: values.opRecieptPrinter,
          pharmacyBillPriinter: values.pharmacyBillPriinter,
          deviceConfig: deviceConfigJson,
        };

        console.log(data);

        const response = await axios.post(`${BASE_URL}${SAVE_PRINTER}`, data, {
          headers: {
            'XApiKey': process.env.REACT_APP_API_KEY,
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          toast.success('Printer settings saved successfully', { 
            autoClose: 1000,
            icon: '🖨️'
          });

          const updatedSysInfo = {
            ...sysInfo,
            OpBillPrinter: values.opBillPrinter,
            OpBillCardPrinter: values.opBillCardPrinter,
            opRecieptPrinter: values.opRecieptPrinter,
            ZoomFactor: values.zoomFactor,
            pharmacyBillPriinter: values.pharmacyBillPriinter,
            deviceConfig: deviceConfigJson,
          };

          if(isElectron()){
            await ipcRenderer.invoke('store-set', 'sysInfo', updatedSysInfo);
          }
          
          resetForm();
          getData(systemName);
          
        } else {
          toast.error('Something went wrong!', { duration: 1000 });
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'An error occurred', { duration: 1000 });
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });
  
  // Loading indicator
  const LoadingSpinner = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
        <p className="text-indigo-600 font-medium">Loading printer settings...</p>
      </div>
    </div>
  );

  // Select field component for printers
  const SelectField = ({ label, icon, id, options, ...props }) => (
    <div className="mb-4">
      <label htmlFor={id} className=" text-sm font-medium text-gray-700 mb-2 flex items-center">
        {icon}
        <span className="ml-2">{label}</span>
      </label>
      <select
        id={id}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
        {...props}
      >
        <option value="">Select a printer</option>
        {options.map((option, index) => (
          <option key={index} value={option.name}>{option.name}</option>
        ))}
      </select>
    </div>
  );

  // Select field component for zoom factor
  const ZoomFactorSelect = ({ label, icon, id, options, ...props }) => (
    <div className="mb-4">
      <label htmlFor={id} className=" text-sm font-medium text-gray-700 mb-2 flex items-center">
        {icon}
        <span className="ml-2">{label}</span>
      </label>
      <select
        id={id}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
        {...props}
      >
        <option value="">Select zoom factor</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>{option.name}</option>
        ))}
      </select>
    </div>
  );

  // Generic select field component for dropdowns
  const GenericSelect = ({ label, icon, id, options, placeholder, ...props }) => (
    <div className="mb-4">
      <label htmlFor={id} className=" text-sm font-medium text-gray-700 mb-2 flex items-center">
        {icon}
        <span className="ml-2">{label}</span>
      </label>
      <select
        id={id}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
        {...props}
      >
        <option value="">{placeholder || 'Select an option'}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>{option.name}</option>
        ))}
      </select>
    </div>
  );

  return (
    <div className="p-6">
      <ToastContainer
        position="top-center"
        autoClose={1000}
        limit={1}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      
      {(loading || formik.isSubmitting) && <LoadingSpinner />}
      
      <div className="bg-white rounded-xl mb-6">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center mb-4">
            <FiServer className="text-indigo-600 mr-2" size={20} />
            <h2 className="text-xl font-semibold text-gray-800">System Configuration</h2>
          </div>
          
          <div className="bg-indigo-50 p-4 rounded-lg flex items-start mb-6">
            <FiInfo className="text-indigo-600 mt-1 mr-3 flex-shrink-0" />
            <p className="text-sm text-indigo-700">
              Configure your system's printer settings. These settings determine which printers will be used for various document types.
            </p>
          </div>
          {!isElectron() && (
            <div className="bg-indigo-50 p-4 rounded-lg flex items-start mb-6">
              <FiInfo className="text-red-600 mt-1 mr-3 flex-shrink-0" />
              <p className="text-sm text-red-700">
                This feature will only work with our windows application
              </p>
            </div>
          )}
          
          
          
          <form onSubmit={formik.handleSubmit} className="space-y-6">
            <div className="flex flex-col w-full">
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <div className="flex items-center mb-2">
                  <FiMonitor className="text-gray-500 mr-2" />
                  <h3 className="font-medium text-gray-700">System Information</h3>
                </div>
                <div className="px-4 py-3 bg-white rounded-lg border border-gray-200">
                  <label className="block text-xs text-gray-500 uppercase mb-1">System Name</label>
                  <div className="font-medium text-gray-800">{systemName || 'Not detected'}</div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6">
              
              <div>
                <SelectField
                  label="Pharmacy Bill Printer"
                  icon={<FiPrinter className="text-indigo-500" />}
                  id="pharmacyBillPriinter"
                  options={printers}
                  {...formik.getFieldProps('pharmacyBillPriinter')}
                />
                
              </div>
              <div>
                <SelectField
                  label="General Bill Printer"
                  icon={<FiPrinter className="text-indigo-500" />}
                  id="opBillPrinter"
                  options={printers}
                  {...formik.getFieldProps('opBillPrinter')}
                />
                
              </div>
              <div>   
                <ZoomFactorSelect
                  label="Zoom Factor"
                  icon={<FiZoomIn className="text-indigo-500" />}
                  id="zoomFactor"
                  options={zoomFactorOptions}
                  {...formik.getFieldProps('zoomFactor')}
                />
              </div>
              <div>
                <GenericSelect
                  label="Pharmacy Bill Type"
                  icon={<FiPrinter className="text-indigo-500" />}
                  id="phbilltype"
                  options={phBillTypeOptions}
                  placeholder="Select bill type"
                  {...formik.getFieldProps('phbilltype')}
                />
              </div>
              <div>
                <GenericSelect
                  label="Pharmacy Bill Template"
                  icon={<FiPrinter className="text-indigo-500" />}
                  id="phbilltemplate"
                  options={phBillTemplateOptions}
                  placeholder="Select bill template"
                  {...formik.getFieldProps('phbilltemplate')}
                />
              </div>
            </div>
            
            <div className="flex justify-end pt-4">
              <button 
                type="submit" 
                disabled={loading || formik.isSubmitting}
                className="flex items-center px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium rounded-lg shadow hover:from-indigo-700 hover:to-purple-700 transition-all duration-200"
              >
                <FiSave className="mr-2" />
                Save Printer Settings
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSettings;